import { Epic } from 'redux-observable';
import { Observable } from 'rxjs';

import { Action } from '../actions';
import {
    ChangeLocationHard,
    changeLocationHard,
    dummyAction,
    DummyAction,
    updateAuthorizationData,
    UpdateAuthorizationDataAction
} from '../actions/common';
import { NoticeType, showNoticeMessage } from '../actions/grid-screen';
import {
    FetchHeaderWalletInfo,
    fetchHeaderWalletInfo
} from '../actions/header';
import {
    baseUserSettingsSubmitted,
    BaseUserSettingsSubmitted,
    baseUserSettingsSubmittedMetrika,
    BaseUserSettingsSubmittedMetrikaAction,
    SUBMIT_BASE_USER_SETTINGS,
    SubmitBaseUserSettings
} from '../actions/welcome-screen';
import { mapAuthorizationData } from '../mappers/common/common';
import { mapWelcomeBannerType } from '../mappers/welcome';
import { ApiMethodExecutingError } from '../service/Errors';
import '../service/Rx';
import { EpicDeps } from '../service/StoreFactory';
import { State } from '../typings/state';

const welcomeDataEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(SUBMIT_BASE_USER_SETTINGS)
        .mergeMap((action: SubmitBaseUserSettings) => {
            const storeData = store$.value;
            const {
                email,
                country,
                currency,
                isAccepted
            } = storeData.welcome.baseSettings;

            return Observable.fromPromise(
                deps.restApiManager.saveWelcomePageData(
                    email,
                    country,
                    currency,
                    isAccepted
                )
            )
                .mergeMap(
                    (response): Observable<Action> => {
                        const welcomeBanner = mapWelcomeBannerType(response);
                        let outAction$: Observable<
                            | ChangeLocationHard
                            | BaseUserSettingsSubmitted
                            | BaseUserSettingsSubmittedMetrikaAction
                            | FetchHeaderWalletInfo
                            | UpdateAuthorizationDataAction
                            | DummyAction
                        >;

                        if (action.retpath) {
                            outAction$ = Observable.of(
                                changeLocationHard(action.retpath)
                            );
                        } else {
                            outAction$ = Observable.concat(
                                Observable.of(
                                    baseUserSettingsSubmitted(
                                        true,
                                        welcomeBanner
                                    )
                                ),
                                Observable.fromPromise(
                                    deps.commonDataProvider.fetchAuthorizationData()
                                )
                                    .mergeMap(authData =>
                                        Observable.concat(
                                            Observable.of(
                                                updateAuthorizationData(
                                                    mapAuthorizationData(
                                                        authData.data
                                                    )
                                                )
                                            ),
                                            Observable.of(
                                                fetchHeaderWalletInfo()
                                            )
                                        )
                                    )
                                    .catch(() => Observable.of(dummyAction))
                            );
                        }

                        return Observable.concat(
                            Observable.of(
                                baseUserSettingsSubmittedMetrika(welcomeBanner)
                            ),
                            outAction$
                        );
                    }
                )
                .catch(
                    (err: ApiMethodExecutingError): Observable<Action> => {
                        showNoticeMessage(NoticeType.error, err.getMessage());
                        return Observable.of(baseUserSettingsSubmitted(false));
                    }
                );
        });
};

export { welcomeDataEpic };
